export default __webpack_public_path__ + "static/media/swim.18d6047e.png";